import { Diamond, type LucideIcon } from "lucide-react";

import Box from "@mui/material/Box";
import { keyframes } from "@mui/material";
import { GET_STARTED_GRADIENT } from "./getStartedStyles";

const driftA = keyframes`
  0%, 100% { transform: translate(0, 0) rotate(0deg) scale(1) skew(0deg); }
  50% { transform: translate(44px, -18px) rotate(8deg) scale(1.18) skew(5deg); }
`;

const driftB = keyframes`
  0%, 100% { transform: translate(0, 0) rotate(0deg) scale(1); }
  50% { transform: translate(-32px, 40px) rotate(-10deg) scale(0.82) skew(10deg); }
`;

const driftC = keyframes`
  0%, 100% { transform: translate(0, 0) rotate(0deg) scale(1); }
  50% { transform: translate(14px, 22px) rotate(6deg) scale(1.12); }
`;

type FloatingShape = {
  Icon: LucideIcon;
  top: string;
  left: string;
  opacity: number;
  drift: ReturnType<typeof keyframes>;
  duration: string;
  delay: string;
  filter: string;
} & (
  | { size: number; width?: undefined; height?: undefined }
  | { size?: undefined; width: number; height: number }
);

const FLOATING_SHAPES: FloatingShape[] = [
  {
    Icon: Diamond,
    top: "18%",
    left: "7%",
    width: 44,
    height: 60,
    opacity: 0.314,
    drift: driftA,
    duration: "9s",
    delay: "0s",
    filter: "blur(1px)",
  },
  {
    Icon: Diamond,
    top: "64%",
    left: "15%",
    size: 40,
    opacity: 0.312,
    drift: driftB,
    duration: "13s",
    delay: "1.2s",
    filter: "blur(3px)",
  },
  {
    Icon: Diamond,
    top: "22%",
    left: "84%",
    width: 60,
    height: 80,
    opacity: 0.31,
    drift: driftC,
    duration: "13s",
    delay: "0.6s",
    filter: "blur(2px)",
  },
  {
    Icon: Diamond,
    top: "12%",
    left: "50%",
    size: 42,
    opacity: 0.31,
    drift: driftC,
    duration: "8s",
    delay: "0.6s",
    filter: "blur(4px)",
  },
  {
    Icon: Diamond,
    top: "70%",
    left: "88%",
    size: 44,
    opacity: 0.316,
    drift: driftA,
    duration: "10s",
    delay: "2s",
    filter: "blur(2px)",
  },
];

export const FloatingShapes = () => (
  <>
    {FLOATING_SHAPES.map(
      (
        {
          Icon,
          top,
          left,
          size,
          width,
          height,
          opacity,
          drift,
          duration,
          delay,
          filter,
        },
        i
      ) => (
        <Box
          key={i}
          aria-hidden
          sx={{
            position: "absolute",
            top,
            left,
            pointerEvents: "none",
            filter,
            animation: `${drift} ${duration} ease-in-out ${delay} infinite`,
            "@media (prefers-reduced-motion: reduce)": { animation: "none" },
          }}
        >
          <Icon
            fill={`rgba(255, 255, 255, ${opacity})`}
            color="transparent"
            width={width ?? size}
            height={height ?? size}
            strokeWidth={1.5}
            preserveAspectRatio="none"
          />
        </Box>
      )
    )}
  </>
);
